'use client';

import { useLiveQuery } from '@sanity/preview-kit';
import { defaultLanguage } from '@stereoagency/constants';
import {
  researchProjectByIdQuery,
  researchProjectPageLinkedResearchContentQuery
} from './researchProjectPageQuery';
import ResearchProjectPage from './ResearchProjectPage.client';
import { findInKeyArray } from '@/utils';
import { PageSections } from '@/components/layout';

interface Props {
  id: string;
  lang: string;
}

export default function DraftModeArticlePage({ id, lang }: Props) {
  const [data] = useLiveQuery<(typeof researchProjectByIdQuery)[1] | null>(
    null,
    researchProjectByIdQuery[0],
    { id }
  );

  const [linkedResearchContent] = useLiveQuery<
    (typeof researchProjectPageLinkedResearchContentQuery)[1] | null
  >(null, researchProjectPageLinkedResearchContentQuery[0], { id });

  if (data == null) {
    return null;
  }

  const content = data.content
    ? findInKeyArray(data.content, [lang, defaultLanguage.id])
    : null;

  return (
    <ResearchProjectPage
      lang={lang}
      page={data}
      linkedResearchContent={linkedResearchContent?.linkedResearchContent}
      content={
        content?.value ? <PageSections sections={content?.value ?? []} /> : null
      }
    />
  );
}
